import { render, staticRenderFns } from "./OrdersListComponent.vue?vue&type=template&id=18c25f3e&scoped=true"
import script from "./OrdersListComponent.vue?vue&type=script&lang=ts"
export * from "./OrdersListComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c25f3e",
  null
  
)

export default component.exports